document.querySelectorAll('[data-custom-main-slider]').forEach(function (sliderRoot) {
  var paginationContainer = sliderRoot.querySelector('.swiper-pagination')
  var swiper = sliderRoot.lpMainSwiper || sliderRoot.swiper

  if (!paginationContainer || !swiper || !swiper.autoplay) return
  if (paginationContainer.querySelector('.swiper-pause-play-self')) return

  var pausePlayButton = document.createElement('div')
  pausePlayButton.className = 'swiper-pause-play-self play'
  pausePlayButton.innerHTML = '<span class="pause-play-icon"></span>'
  paginationContainer.appendChild(pausePlayButton)

  pausePlayButton.addEventListener('click', function () {
    if (swiper.autoplay.running) {
      swiper.autoplay.stop()
      pausePlayButton.classList.remove('play')
      pausePlayButton.classList.add('paused')
      return
    }

    swiper.autoplay.start()
    pausePlayButton.classList.remove('paused')
    pausePlayButton.classList.add('play')
  })
})
